import {
  type CSSProperties,
  type KeyboardEventHandler,
  type ReactNode,
  type RefObject,
  useCallback,
  useRef,
  useState,
} from 'react';

import classNames from 'classnames';

import styles from './DataTableViewport.module.css';

export const DataTableViewport = ({
  topOffset,
  className,
  onKeyDownCapture,
  children,
}: {
  topOffset?: number;
  className?: string;
  onKeyDownCapture?: KeyboardEventHandler<HTMLDivElement>;
  children: (
    scrollRef: RefObject<HTMLDivElement>,
    scrollElement: HTMLDivElement | null,
  ) => ReactNode;
}): JSX.Element => {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(
    null,
  );
  const setScrollRef = useCallback((element: HTMLDivElement | null) => {
    scrollRef.current = element;
    setScrollElement(element);
  }, []);
  return (
    <div
      ref={setScrollRef}
      onKeyDownCapture={onKeyDownCapture}
      className={classNames(styles.viewport, className)}
      style={
        {
          '--data-table-viewport-top-offset': `${topOffset ?? 0}px`,
        } as CSSProperties
      }
    >
      {children(scrollRef, scrollElement)}
    </div>
  );
};
